import React, {useState, useEffect} from 'react';
import axios from '../Common/axios';
import { useParams } from 'react-router-dom';
import {Layout, Table, Typography} from "antd";
import {getFindReportIdInfo, getFindInfoAssetListDataOk} from '../Common/api';
import {assetListData} from '../Common/tempData';
import {getGridTableHeight} from '../Common/util';

const {Sider} = Layout;

/** -------------------------------------------------------------------------- **/
function VaAssetList({reportId, assetType, reportName, onClickAsset, autoDisplay}) {
    const params = useParams();

    // 변수 선언
    const [assetCd, setAssetCd] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    //const [dataSource, setDataSource] = useState(assetListData);
    const [dataSource, setDataSource] = useState([]);
   
    // 자산관리_목록
    const assetColumnData = [
        {
            title: '코드',
            dataIndex: 'asset_cd',
            key: 'asset_cd',
            width: '50px',
            align: 'center',
        },
        {
            title: '자산명',
            dataIndex: 'asset_nm',
            key: 'asset_nm',
            width: '100px',
            align: 'center',
            render: (_ , rowData ) => {
                return (
                    <Typography.Link onClick={() => onClickAsset(rowData.asset_cd)}>
                        {rowData.asset_nm}
                    </Typography.Link>
                );
            },
        },
    ];
    
    /** -------------------------------------------------------------------------- **/
    useEffect(() => {
        findAssetListData();
    }, [reportId]);
 
    // 자산정보 조회 API
    const findAssetListData = async () => {
        try {
            setIsLoading(true);
            const response = await axios.get(getFindInfoAssetListDataOk(reportId));
            setDataSource(response.data);
            // 대시보드에서 자산정보 자동 선택 방지하고용
            // 취약점 상세정보 조회시에는 자동 선택하게 적용 
            if(autoDisplay === "show") onClickAsset(response.data[0].asset_cd);
        } catch (error) {
            console.log("VaAssetList.js --- 에러 발생");
            console.dir(error);
            setDataSource([]);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="section" style={{marginRight: '5px'}}>
                <table className='search'>
                    <tbody>
                    <tr>
                        <th> {reportName}</th>
                    </tr>
                    <tr>
                        <th> {assetType}</th>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div className="section">
                <Table columns={assetColumnData}
                    rowKey={(record) => record.asset_cd}
                    dataSource={dataSource}
                    loading={isLoading}
                    pagination={false}
                    bordered size={"small"}
                    style={{height:getGridTableHeight(140)}}
                    scroll={{y: getGridTableHeight(140)}}
                    showSorterTooltip={false}
                />
            </div>
        </>
    );
}
export default VaAssetList;